import { render, staticRenderFns } from "./BulkProjectViewPage.vue?vue&type=template&id=3463fa45&scoped=true&"
import script from "./BulkProjectViewPage.vue?vue&type=script&lang=ts&"
export * from "./BulkProjectViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProjectViewPage.vue?vue&type=style&index=0&id=3463fa45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3463fa45",
  null
  
)

export default component.exports